import { Outlet } from 'react-router'

import { DemoFloatingIndicator } from '@/components/demo-floating-indicator'
import { ImpersonationBanner } from '@/components/impersonation-banner'
import { ModalsContainer } from '@/components/modals/Modals'
import Navbar from '@/components/navbar'
import { AppSidebar } from '@/components/ui/sidebar/app-sidebar'
import { IS_STAGING } from '@/env'
import { SubscriptionGate } from '@/features/subscription/components/subscription-gate'

export const AppRoot = () => {
  return (
    <>
      <div className="flex w-full h-screen">
        <AppSidebar />
        <main className="flex flex-1 flex-col @container/content">
          {IS_STAGING && <DemoFloatingIndicator />}
          <ImpersonationBanner />
          <Navbar />
          <SubscriptionGate>
            <Outlet />
          </SubscriptionGate>
        </main>
      </div>
      <ModalsContainer />
    </>
  )
}
